<template>
  <v-row class="justify-center" transition="slide-x-transition">
    <v-col cols="12" sm="8" md="6" lg="5" class="d-flex align-stretch pa-1">
      <v-card class="flex-grow-1">
        <v-toolbar color="grey lighten-4" elevation="0" light dense>
          <v-toolbar-title>Atualização Cadastral</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$router.go(-1)">
            <v-icon>fa-solid fa-reply</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-subtitle class="text-left">
          Para solicitar a segunda via da carteirinha do seu plano preencha o formulário abaixo:
        </v-card-subtitle>
        <v-card-text>
        <v-form
          ref="formUserDataUpdate"
          lazy-validation
        >

              <v-text-field
                v-model="formData.nome"
                :rules="formRules.nameRules"
                label="Nome Completo"
                required
                dense
              ></v-text-field>

              <v-text-field
                v-model="formData.email"
                label="E-mail"
                dense
              ></v-text-field>
              <v-text-field
                v-model="formData.telresidencial"
                v-mask="'(##) ####-#####'"
                label="Telefone"
                dense
              ></v-text-field>
              <v-text-field
                v-model="formData.telcelular"
                v-mask="'(##) #####-####'"
                label="Celular"
                dense
              ></v-text-field>
              <v-text-field
                v-model="formData.logradouro"
                label="Endereço Completo"
                dense
              ></v-text-field>
              <v-text-field
                v-model="formData.bairro"
                label="Bairro"
                dense
              ></v-text-field>
              <v-text-field
                v-model="formData.cidade"
                label="Cidade"
                dense
              ></v-text-field>
              <v-text-field
                v-model="formData.uf"
                label="Estado"
                dense
              ></v-text-field>
        </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined 
            color="grey"
            class="mr-4"
            @click="reset"
          >
            Limpar
          </v-btn>
          <v-btn
            :disabled="!valid"
            outlined 
            color="primary"
            class="mr-4"
            @click="sendMail"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
var moment = require('moment')
import { mask } from 'vue-the-mask'

export default {
  directives: {
      mask
  },
  data() {
    return {
      allBeneficiaries: [],
      beneficiary: '',
      formData: {
        token: this.$store.state.tokenSms,
        nome: '',
        telcelular: '',
        telresidencial: '',
        email: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        uf: ''
      },
      binarylist: [
        'Sim',
        'Não'
      ],
      valid: true
    }
  },
  watch: {
    plans: {
      immediate: true,
      handler(newVal) {
        this.fillForm()
      }
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules,
      plans: state => state.plans.plans
    })
  },
  methods: {
    fillForm() {
      if(this.plans && this.plans[0]) {
      let { cep, logradouro, numero, complemento, bairro, cidade, uf } = this.plans[0].endereco
      let { telcelular, telresidencial, email } = this.plans[0].contato
      this.formData = {
        token: this.$store.state.tokenSms,
        nome: this.plans[0].beneficiarios[0].nome,
        telcelular,
        telresidencial,
        email,
        cep,
        logradouro,
        numero,
        complemento,
        bairro,
        cidade,
        uf
        }
      }
     
    },
    sendMail() {
      let _this = this
      if (this.$refs.formUserDataUpdate.validate()) {
        let tipo = "UserDataUpdate"
        let opts =  this.formData
        this.$store.dispatch("userDataUpdate/sendMail", opts).then(resp => _this.reset())
      }
    },
    reset() {
      this.$refs.formUserDataUpdate.reset()
    },
  }
}
</script>
